<template>
  <loading-chart v-if="type === 'chart'"></loading-chart>

  <loading-chart
    v-else-if="type === 'chart-horizontal'"
    horizontal
  ></loading-chart>

  <v-skeleton-loader
    v-else
    class="zoox-component zoox-skeleton-loader"
    :boilerplate="boilerplate"
    :dark="dark"
    :height="height"
    :width="width"
    :light="light"
    :loading="loading"
    :max-height="maxHeight"
    :max-width="maxWidth"
    :min-height="minHeight"
    :min-width="minWidth"
    :tile="noBorderRadius"
    :trasition="transition"
    :type="type"
    :types="types"
  >
    <slot></slot>
  </v-skeleton-loader>
</template>

<script>
import LoadingChart from './private/LoadingChart.vue'

/**
 * @displayName Skeleton Loader
 */
export default {
  name: 'ZSkeletonLoader',
  components: {
    LoadingChart,
  },
  props: {
    /**
     * Flag para remover a animação de loading do componente
     */
    boilerplate: {
      type: Boolean,
      default: false,
    },
    /**
     * Flag para definir o tema escuro do componente
     */
    dark: {
      type: Boolean,
      default: false,
    },
    /**
     * Altura do componente
     */
    height: {
      type: [Number, String],
      default: '100%',
    },
    /**
     * Largura do componente
     */
    width: {
      type: [Number, String],
      default: '100%',
    },
    /**
     * Flag para definir o tema claro do componente
     */
    light: {
      type: Boolean,
      default: false,
    },
    /**
     * Aplica uma animação de loading no componente quando há conteúdo no slot `default`
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * Altura máxima do componente
     */
    maxHeight: {
      type: [Number, String],
      default: undefined,
    },
    /**
     * Largura máxima do componente
     */
    maxWidth: {
      type: [Number, String],
      default: undefined,
    },
    /**
     * Altura mínima do componente
     */
    minHeight: {
      type: [Number, String],
      default: undefined,
    },
    /**
     * Largura mínima do componente
     */
    minWidth: {
      type: [Number, String],
      default: undefined,
    },
    /**
     * Flag para remoção de bordas redondas do componente
     */
    noBorderRadius: {
      type: Boolean,
      default: false,
    },
    /**
     * Tipo de transição a ser aplicada no componente
     * <br/><br/>
     * Possiveis valores: [clique aqui](https://vuetifyjs.com/en/styles/transitions/)
     */
    transition: {
      type: String,
      default: 'fade-transition',
    },
    /**
     * Tipo de componente a ser renderizado.
     * <br/><br/>
     * Possiveis valores: [clique aqui](https://vuetifyjs.com/en/api/v-skeleton-loader/#props-type)
     */
    type: {
      type: String,
      default: 'card',
    },
    /**
     * Um objeto customizado que será combinado com as opções pré-definidas.
     *
     * <br/><br/>
     *
     * Para a lista completa de opções pre-definidas, veja a prop **type**
     */
    types: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
